export enum OperacaoFormularioCRUD {
  Visualizar = 'Visualizar',
  Criar = 'Criar',
  Atualizar = 'Atualizar',
  // Remover = 'Remover',
}

export enum OperacaoFormularioBusca {
  Buscar = 'Buscar',
}